export const getAccounts = state => state.admin.departments.accounts;
export const getCatalogTypes = state => state.admin.departments.catalogTypes;
